  import React, { Component } from "react";
  import {
    Row,
    Col,
    Button,
    Tabs,
    Nav,
    Tab,
    Table,
    Modal,
    Image,
    Container
  } from "react-bootstrap";
  import { appConfig } from "../../config";

  var dateFormat = require("dateformat");

  class SupportView extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    render() {
      console.log(this.props.supportDetail);

      const data =
        this.props.supportDetail && this.props.supportDetail.item
          ? this.props.supportDetail && this.props.supportDetail.item
          : null;

      return (
        <div>
          <div className="modelboxdesigns">
            <Modal
              show={this.props.show}
              onHide={this.props.close}
              animation={false}
              size="lg"
              backdrop="static"
              style={{ backgroundColor: "#00000010" }}
            >
              <Modal.Header
                style={{
                  fontSize: "35px",
                  backgroundColor: "#1768B7",
                  color: "white"
                }}
                closeButton
              >
                <Modal.Title>
                  <span style={{ fontSize: "20px" }}> Support Details</span>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div>
                  <div className="feedbkModalTbl">
                    <Table responsive bordered>
                      <tbody className="tableBody">
                        <tr>
                          <td>Ticket No</td>
                          <td className="feedbkModalCap">
                            {data !== null && data.ticketNo}
                          </td>
                        </tr>
                        <tr>
                          <td>Support</td>
                          <td className="feedbkModalCap">
                            {data !== null && data.issueDesc}
                          </td>
                        </tr>
                        <tr>
                          <td> Support Type</td>
                          <td className="feedbkModalCap">
                            {data && data.sprtType && data.sprtType.disc}
                          </td>
                        </tr>

                        <tr>
                          <td>Created Date</td>
                          <td className="feedbkModalCap">
                            {data !== null &&
                              dateFormat(data.createdAt, "mediumDate")}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      );
    }
  }

  export default SupportView;
